"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = chooseHigherContrast;

var _calculateContrastRatio = _interopRequireDefault(require("./calculateContrastRatio"));

/**
 * This function takes 2 possible foreground colors and returns the one which would create larger
 * contrast against the specified background. It can be used when you are deciding about the best
 * color for accessibility purposes (the one with higher contrast is better).
 */
function chooseHigherContrast(rgbForegroundA, rgbForegroundB, rgbBackground) {
  var foregroundAContrastRatio = (0, _calculateContrastRatio.default)(rgbForegroundA, rgbBackground);
  var foregroundBContrastRatio = (0, _calculateContrastRatio.default)(rgbForegroundB, rgbBackground);
  return foregroundAContrastRatio >= foregroundBContrastRatio ? rgbForegroundA : rgbForegroundB;
}